export const paymentImageAssets = import.meta.glob(
  '@/assets/images/provet-pay/*.png',
  { eager: true, import: 'default' },
) as Record<string, string>
